import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Box, Button } from "@mui/material";
import CheeseburgerOverlay from "src/components/header/cheeseburger-overlay";

const BurgerIcon = styled(Button)`
    width: 2rem;
    height: 2rem;
    position: fixed;
    top: 18px;
    right: 20px;
    background-color: ${({ theme }) => theme.palette.background.default};
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
`;

const BurgerLine = styled.div`
    width: 1.8rem;
    height: 0.25rem;
    background-color: ${({ theme }) => theme.palette.secondary.main};
    border-radius: 14px;
    transform-origin: 5px;
    transition: all 0.3s linear;

    &:nth-child(1) {
        transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }

    &:nth-child(2) {
        transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
        opacity: ${({ open }) => (open ? "0" : "1")};
    }

    &:nth-child(3) {
        transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
`;

const CheeseBurger = ({ isDisemboweled }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [open]);

    return (
        <Box>
            <BurgerIcon open={open} onClick={() => setOpen(!open)}>
                <BurgerLine />
                <BurgerLine />
                <BurgerLine />
            </BurgerIcon>
            <CheeseburgerOverlay open={open} setOpen={setOpen} isDisemboweled={isDisemboweled} />
        </Box>
    );
};

export default CheeseBurger;
